import { FC, ReactNode, useEffect, useState } from "react";
import { Outlet } from "react-router";
import { Loader2 } from "lucide-react";
import { useUserSwitchMutation } from "../hooks/use-user-switch";
import isWebApp from "../utils/isWebApp";

const UserSwitchHandler: FC<{ children?: ReactNode }> = ({ children }) => {
  const { switchUser } = useUserSwitchMutation();
  const [mutated, setMutated] = useState(false);

  const startParam = isWebApp()
    ? window.Telegram?.WebApp?.initDataUnsafe?.start_param
    : undefined;

  const isUserSwitchParam =
    startParam && startParam.match(/^user_([a-f0-9]{24})$/i);

  useEffect(() => {
    if (isUserSwitchParam && !mutated) {
      const match = startParam!.match(/^user_([a-f0-9]{24})$/i);
      if (match) {
        const userId = match[1];
        switchUser(userId);
        setMutated(true);
      }
    }
  }, [isUserSwitchParam, mutated, startParam, switchUser]);

  if (isUserSwitchParam && !mutated) {
    return <Loader2 className="m-auto animate-spin" />;
  }

  return children ?? <Outlet />;
};

export default UserSwitchHandler;
